import React from 'react';

const TopicFilter = ({ selectedTopic, onTopicChange }) => {
  const topics = [
    { value: 'all', label: 'All Topics' },
    { value: 'personal_finance', label: 'Personal Finance' },
    { value: 'investment_tips', label: 'Investment Tips' },
    { value: 'budgeting_strategies', label: 'Budgeting Strategies' },
    { value: 'market_analysis', label: 'Market Analysis' },
    { value: 'debt_management', label: 'Debt Management' },
    { value: 'savings_goals', label: 'Savings Goals' },
    { value: 'tax_planning', label: 'Tax Planning' },
    { value: 'retirement_planning', label: 'Retirement Planning' }
  ];

  return (
    <div className="mb-20">
      <div className="flex flex-wrap gap-8">
        {topics?.map((topic) => (
          <button
            key={topic?.value}
            onClick={() => onTopicChange(topic?.value)}
            className={`px-16 py-8 rounded-full text-sm font-medium transition-all ${
              selectedTopic === topic?.value
                ? 'bg-primary text-primary-foreground shadow-md'
                : 'bg-card border border-border text-muted-foreground hover:border-primary hover:text-primary'
            }`}
          >
            {topic?.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TopicFilter;